import Vue from 'vue'
import { MoyenPaiement } from '@/enum/MoyenPaiement'
import { TypeReduction } from '@/enum/TypeReduction'

Vue.filter('fileIcons', function(value: string ) {
  if (value) {
    switch(value){       
      case ".docx":
      case ".doc":
        return 'mdi-file-word'
      case ".pdf":
        return 'mdi-file-pdf'
    }            
  }
  return 'mdi-file-document-outline'
})